import Phaser from 'phaser';

export class AudioManager {
  private unlocked = false;
  private muted = false;
  private context?: AudioContext;

  constructor(private readonly scene: Phaser.Scene) {}

  unlock(): void {
    this.unlocked = true;
    this.scene.sound.unlock();
    const AudioContextClass = window.AudioContext ?? (window as typeof window & { webkitAudioContext?: typeof AudioContext }).webkitAudioContext;
    if (AudioContextClass) {
      this.context ??= new AudioContextClass();
      void this.context.resume();
    }
  }

  toggle(): boolean {
    this.muted = !this.muted;
    this.scene.sound.mute = this.muted;
    return this.muted;
  }

  play(key: string): void {
    if (!this.unlocked || this.muted || !this.context) return;
    if (this.scene.cache.audio.exists(key)) {
      this.scene.sound.play(key, { volume: key === 'hurry-up' ? 0.28 : 0.4 });
      return;
    }
    const notes: Record<string, [number, number, number]> = {
      start: [523, 0.12, 0.09], jump: [370, 0.11, 0.08], coin: [784, 0.08, 0.07],
      'block-hit': [196, 0.1, 0.09], star: [659, 0.24, 0.1], unlocked: [523, 0.34, 0.1]
    };
    const [frequency, length, volume] = notes[key] ?? notes.coin;
    const oscillator = this.context.createOscillator();
    const gain = this.context.createGain();
    oscillator.type = key === 'block-hit' ? 'square' : 'triangle';
    oscillator.frequency.setValueAtTime(frequency, this.context.currentTime);
    gain.gain.setValueAtTime(volume, this.context.currentTime);
    gain.gain.exponentialRampToValueAtTime(0.001, this.context.currentTime + length);
    oscillator.connect(gain).connect(this.context.destination);
    oscillator.start(); oscillator.stop(this.context.currentTime + length);
  }
}
